export type ResearchArticle = {
    slug: string;
    title: string;
    description: string;
    date?: string;
};

export const researchArticles: ResearchArticle[] = [
    {
        slug: 'introducing-mira',
        title: 'Introducing MIRA',
        date: 'April 24, 2026',
        description: 'Memory Inference and Retrieval Architecture - a memory system for AI.'
    },
    {
        slug: 'when-alive-stops-being-the-operational-question',
        title: 'When “Alive” Stops Being the Operational Question',
        date: 'April 8, 2026',
        description: 'On functional internal states, deception, tool use, and the threshold at which AI emotions become real enough to matter.'
    },
    {
        slug: 'ai-memory',
        title: 'AI Memory',
        description: 'Persistent memory architectures for AI systems that remember, learn, and adapt over time.'
    }
];
